import store from "@/store/store";

/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkPerm(value) {
  if (value && value instanceof Array && value.length > 0) {
    const all_permission = "*:*:*";
    const permissions = store.state && store.state.permissions;
    const permissionList = value;

    return permissions.some(permission => {
      return all_permission === permission || permissionList.includes(permission);
    });
  } else {
    return false;
  }
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkRole(value) {
  if (value && value instanceof Array && value.length > 0) {
    const all_permission = "*:*:*";
    const roles = store.state && store.state.roles;
    const permissionRoles = value;

    return roles.some(role => {
      return role === all_permission || permissionRoles.includes(role);
    });
  } else {
    return false;
  }
}
